import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrescriptionNoteService } from './prescription-note.service';
import { Observable } from 'rxjs';
import { Note } from './prescription-note-model';
import { LayoutUtilsService, MessageType } from 'src/app/core/_base/crud';

@Component({
  selector: 'kt-prescription-note',
  templateUrl: './prescription-note.component.html',
  styleUrls: ['./prescription-note.component.scss'],
})
export class PrescriptionNoteComponent implements OnInit {
  notes: Array<Note> = [];
  selectedNoteIndex: number | null = null;
  isAddingNew = false;
  loading = true;
  currentNote: Note = {
    note: '',
    createdBy: '',
    createdDate: '',
    pinned: false,
    active: false,
    id: 0,
  };
  prescription: any;
  prescriptionId: number;
  viewPrescriptionNote = false;
  active: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private prescriptionNoteService: PrescriptionNoteService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
  ) {
    this.prescription = this.data.prescription || this.data.card;
    if (this.data.cardHasNotes) {
      this.prescriptionId = this.data.card?.prescription?.id;
    } else this.prescriptionId = this.prescription.id;

    this.viewPrescriptionNote = this.data.viewPrescriptionNote;
  }

  ngOnInit(): void {
    this.getNotes().subscribe((response) => {
      this.mapApiResponseToNotes(response);
      this.loading = false;
      this.cdr.detectChanges();
    });
  }

  togglePin() {
    if (!this.viewPrescriptionNote && this.selectedNoteIndex !== null) {
      const note = this.notes[this.selectedNoteIndex];
      this.currentNote.active = !this.currentNote.active;

      note.active = !note.active;
      const requestBody = {
        note: note.note,
        active: note.active,
        pinned: note.pinned,
      };
      this.updateNoteOnServer(note.id, requestBody);
    }
    if (!this.viewPrescriptionNote && this.selectedNoteIndex == null) {
      this.currentNote.active = !this.currentNote.active;
    }
  }

  getNotes(): Observable<any> {
    return this.prescriptionNoteService.getNotes(this.prescriptionId);
  }

  mapApiResponseToNotes(response: any): void {
    if (response && response.data) {
      this.notes = response.data.map((item: any) => ({
        note: item.note,
        createdBy: this.data.currentUser.userName,
        createdDate: new Date(item.created).toLocaleDateString(),
        pinned: item.pinned,
        id: item.id,
        active: item.active ?? false,
      }));
    }
  }

  selectNote(index: number): void {
    this.isAddingNew = false;
    this.selectedNoteIndex = index;
    this.currentNote = { ...this.notes[index] };
  }

  addNewNote(): void {
    this.isAddingNew = true;
    this.selectedNoteIndex = null;
    this.currentNote = {
      note: '',
      createdBy: this.data.currentUser.userName,
      createdDate: new Date().toLocaleDateString(),
      pinned: false,
      active: false,
      id: 0,
    };
  }

  saveNote(): void {
    if (this.selectedNoteIndex !== null) {
      this.notes[this.selectedNoteIndex] = { ...this.currentNote };

      const requestBody = {
        note: this.currentNote.note,
        pinned: this.currentNote.pinned,
        active: this.currentNote.active,
      };

      this.updateNoteOnServer(this.currentNote.id, requestBody);
    } else {
      this.createNote(this.currentNote);
    }
  }

  pinNote(index: number): void {
    if (!this.viewPrescriptionNote) {
      const note = this.notes[index];
      note.pinned = !note.pinned;

      const requestBody = {
        note: note.note,
        active: note.active,
        pinned: note.pinned,
      };

      this.updateNoteOnServer(note.id, requestBody);
    }
  }

  updateNoteOnServer(noteId: number, requestBody: any): void {
    this.prescriptionNoteService.updateNote(noteId, requestBody).subscribe(() => {
      this.getNotes().subscribe((result) => {
        this.mapApiResponseToNotes(result);
      });
      const message = 'Updated Successfully ';
      this.layoutUtilsService.showActionNotification(
        message,
        MessageType.Update,
        3000,
        false,
        false,
      );
    });
  }

  deleteNote(): void {
    if (this.selectedNoteIndex !== null) {
      const noteId = this.notes[this.selectedNoteIndex].id;
      this.notes.splice(this.selectedNoteIndex, 1);
      this.resetForm();
      // Call the service to delete the note from the server
      this.prescriptionNoteService.deleteNote(noteId).subscribe(() => {
        const message = 'Deleted Successfully ';
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Delete,
          3000,
          false,
          false,
        );
      });
    }
  }

  resetForm(): void {
    this.currentNote = {
      note: '',
      createdBy: '',
      createdDate: '',
      pinned: false,
      active: false,
      id: 0,
    };
    this.selectedNoteIndex = null;
    this.isAddingNew = false;
  }

  createNote(note: Note): void {
    const requestBody = {
      prescriptionId: this.prescriptionId,
      pmsPrescriptionId: this.prescription.pmsPrescriptionId,
      note: note.note,
      active: note.active,
      pinned: false,
    };

    this.prescriptionNoteService.createNote(this.prescriptionId, requestBody).subscribe(() => {
      this.getNotes().subscribe((result) => {
        this.mapApiResponseToNotes(result);
      });
      const message = 'Created Successfully ';
      this.layoutUtilsService.showActionNotification(
        message,
        MessageType.Create,
        3000,
        false,
        false,
      );
    });
  }
}
